import React from 'react';
import { BrowserRouter ,Routes, Route } from 'react-router-dom';
import Home from '../Pages/Home/Home';
import NotFoundPage from '../Pages/ErrorPages/NotFoundPage';
import AboutUs from '../Pages/AboutUs/AboutUs';
import Objective from '../Pages/AboutText/Objective';
import History from '../Pages/AboutText/History';
import Vision from '../Pages/AboutText/Vision';
import Mission from '../Pages/AboutText/Mission';
import TermsConditions from '../Pages/TermsConditions/TermsConditions';
import PrivacyPolicy from '../Pages/PrivacyPolicy/PrivacyPolicy';
import ContactUs from '../Pages/ContactUs/ContactUs';
// Auth imported here
import Signin from '../Pages/Auth/SignIn';
import FogotPassword from '../Pages/Auth/FogotPassword';
import Otp from '../Pages/Auth/otp';
import NewPassword from '../Pages/Auth/NewPassword';
import SignUp from '../Pages/Auth/SignUp';
import Services from '../Pages/Services/Services';
import SingleService from '../Pages/Services/SingleService';
import Booking from '../Pages/Booking/Booking';
// User Pags Imported Here
import InfoUser from '../Pages/UserProfile/InfoUser';
import EditProfileUser from '../Pages/UserProfile/EditProfileUser';
import UpdatePasswordUser from '../Pages/UserProfile/UpdatePasswordUser';
import UserAppointments from '../Pages/UserProfile/UserAppointments';
import AppointmentDetailsUser from '../Pages/UserProfile/AppointmentDetailsUser';
// therapist Pages Start Here
import InfoTherapist from '../Pages/TherapistProfile/InfoTherapist';
import EditProfileTherapist from '../Pages/TherapistProfile/EditProfileTherapist';
import UpdatePasswordTherapist from '../Pages/TherapistProfile/UpdatePasswordTherapist';
import TherapistAppointments from '../Pages/TherapistProfile/TherapistAppointments';
import AppointmentDetailsTherapist from '../Pages/TherapistProfile/AppointmentDetailsTherapist';
import TherapistServices from '../Pages/TherapistProfile/TherapistServices';
import TherapistAddService from '../Pages/TherapistProfile/TherapistAddService';
import TherapistChat from '../Pages/TherapistProfile/TherapistChat';
import UserChat from '../Pages/UserProfile/UserChat';
import Timings from '../Pages/TherapistProfile/Timings';
import ThankYou from '../Pages/Booking/ThankYou';
const PublicRoutes = () => {
    const UserUrl = "/user";
    const TherapistUrl = "/therapist";
    return(
        <BrowserRouter>
            <Routes>
                <Route path="*" element={<NotFoundPage />} />
                <Route path='/' element={<Home />} />
                <Route path='/aboutus' element={<AboutUs />} />
                <Route path='/objective' element={<Objective />} />
                <Route path='/history' element={<History />} />
                <Route path='/mission' element={<Mission />} />
                <Route path='/vision' element={<Vision />} />
                <Route path='/terms-condition' element={<TermsConditions />} />
                <Route path='/privacy-policy' element={<PrivacyPolicy />} />
                <Route path='/signin' element={<Signin />} />
                <Route path='/forgot-password' element={<FogotPassword />} />
                <Route path='/otp' element={<Otp />} />
                <Route path='/newpassword' element={<NewPassword />} />
                <Route path='/contactus' element={<ContactUs />} />
                <Route path='/signup' element={<SignUp />} />
                <Route path='/services' element={<Services />} />
                <Route path='/service/1' element={<SingleService />} />
                <Route path='/booking' element={<Booking />} />
                <Route path='/thankyou' element={<ThankYou />} />
                {/* User Routes */}
                <Route path={`${UserUrl}/home`} element={<InfoUser />} />
                <Route path={`${UserUrl}/editprofile`} element={<EditProfileUser />} />
                <Route path={`${UserUrl}/updatepassword`} element={<UpdatePasswordUser />} />
                <Route path={`${UserUrl}/appointments`} element={<UserAppointments />} />
                <Route path={`${UserUrl}/appointment/1`} element={<AppointmentDetailsUser />} />
                <Route path={`${UserUrl}/chat`} element={<UserChat />} />
                {/* Therapist Routes */}
                <Route path={`${TherapistUrl}/home`} element={<InfoTherapist />} />
                <Route path={`${TherapistUrl}/editprofile`} element={<EditProfileTherapist />} />
                <Route path={`${TherapistUrl}/updatepassword`} element={<UpdatePasswordTherapist />} />
                <Route path={`${TherapistUrl}/booking`} element={<TherapistAppointments />} />
                <Route path={`${TherapistUrl}/booking/1`} element={<AppointmentDetailsTherapist />} />
                <Route path={`${TherapistUrl}/services`} element={<TherapistServices />} />
                <Route path={`${TherapistUrl}/service/add`} element={<TherapistAddService />} />
                <Route path={`${TherapistUrl}/chat`} element={<TherapistChat />} />
                <Route path={`${TherapistUrl}/timings`} element={<Timings />} />
            </Routes>
        </BrowserRouter>
    )
}
export default PublicRoutes;